import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const ClientDiscount: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        onChange={(value: string) =>
          setSetting({
            alias: ESettingsAliases.CLIENT_DISCOUNT,
            value: value ? '1' : '0',
          })
        }
        value={settings.shouldUseClientDiscount}
        label={t('setting.clientDiscount')}
        description={t('settings.billing.system.discount.description')}
        variant="secondary"
        emptyBg
      />
    </>
  );
};
